import {
    Component,
    Input,
    Output,
    EventEmitter,
    OnInit
} from '@angular/core';
import {
    FormGroup,
    FormControl,
    Validators
} from '@angular/forms';

@Component({
    selector: 'app-power-creep',
    templateUrl: './creep.component.pug',
    styleUrls: ['./creep.component.less']
})
export class CreepComponent implements OnInit {
    @Input() creep: IPowerCreep;
    @Input() creeps: IPowerCreep[];

    @Output() name: EventEmitter<string> = new EventEmitter();

    public form: FormGroup;
    public isEditName: boolean;

    constructor(
    ) {
    }

    ngOnInit() {
        const name = new FormControl('', [Validators.required, Validators.maxLength(50)]);
        this.form = new FormGroup({ name });
    }

    onStartEdit() {
        this.isEditName = true;

        this.form.controls.name.patchValue(this.creep.name);
    }

    onStopEdit(newName) {
        if (this.form.invalid) {
            return;
        }

        if (newName !== this.creep.name) {
            this.name.emit(newName);
        }

        this.isEditName = false;
    }

    isOperator(): boolean {
        return this.creep.className === 'operator';
      }

    isCommander(): boolean {
        return this.creep.className === 'commander';
    }

    idExecutor(): boolean {
        return this.creep.className === 'executor';
    }
}
